<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Functie bewerken</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeEditPositionDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="ma-2 pa-2" v-if="feedback" :value="true" type="warning">
      {{ feedback }}
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="EditPositionForm" lazy-validation>
        <v-text-field
          label="Naam"
          v-model="selectedPositionItem.name"
          prepend-inner-icon="assignment"
          required
          outlined
          hide-details
          :color="companyPrimaryColor"
          class="mt-4"
          :background-color="$vuetify.theme.themes[theme].menu"
        ></v-text-field>
        <v-text-field
          label="Omzet per uur"
          v-model.number="selectedPositionItem.revenue"
          type="number"
          autocomplete
          hint="Doelstelling voor deze functie"
          persistent-hint
          prepend-inner-icon="euro_symbol"
          required
          outlined
          :color="companyPrimaryColor"
          class="mt-4"
          :background-color="$vuetify.theme.themes[theme].menu"
        ></v-text-field>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeEditPositionDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled="!changed || busy"
              :depressed="!changed || busy"
              :dark="changed || busy"
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              rounded
              :color="companySecondaryColor"
              @click="updatePosition()"
            >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";

export default {
  name: "edit-position-form",
  props: {
    activeCompData: Object,
    selectedPositionItem: Object,
    selectedPositionItemOriginal: Object,
  },

  data() {
    return {
      feedback: null,
      busy: false,
    };
  },

  methods: {
    closeEditPositionDialog() {
      this.$emit("editPositionDialogChange", false);
    },

    updatePosition() {
      if (this.selectedPositionItem.name && this.selectedPositionItem.revenue) {
        this.feedback = null;
        this.busy = true;
        db.collection("positions")
          .doc(this.selectedPositionItem.id)
          .set(
            {
              name: this.selectedPositionItem.name,
              revenue: this.selectedPositionItem.revenue,
            },
            { merge: true },
          )
          .then(() => {
            this.busy = false;
            this.$emit("updateData");
            this.closeEditPositionDialog();
            this.$refs.EditPositionForm.reset();
          })
          .catch((error) => {
            this.busy = false;
            console.error("Error adding position: ", error);
          });
      } else {
        this.feedback = "Vul alle velden in om de wijzigingen op te slaan";
      }
    },
  },

  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    changed() {
      if (
        _.isEqual(
          this.selectedPositionItem,
          this.selectedPositionItemOriginal,
        ) == false
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
